import './Home.css'
import { FC, useMemo } from 'react'
import { WALLET_ADAPTER_NETWORK } from '../../utils/wallet-config'
import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react'
import {
  getLedgerWallet,
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletExtensionWallet,
  getSolletWallet,
} from '@solana/wallet-adapter-wallets'
import { NavBar } from '../NavBar/NavBar'
import { Divider } from '@mui/material'
import { MainBox } from '../MainBox/MainBox'
import { clusterApiUrl } from '@solana/web3.js'
import { OpenLoan } from '../OpenLoan/OpenLoan'
import { WalletError } from '@solana/wallet-adapter-base'
import { useNotify } from '../../utils/notify'
import { BottomBar } from '../BottomBar/BottomBar'

export const Home: FC = () => {
  const notify = useNotify()

  const network = WALLET_ADAPTER_NETWORK

  // You can also provide a custom RPC endpoint
  const endpoint = useMemo(() => clusterApiUrl(network), [network])

  // const endpoint = 'http://localhost:8899/'

  // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking --
  // Only the wallets you configure here will be compiled into your application
  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSlopeWallet(),
      getSolflareWallet(),
      getLedgerWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    [network]
  )

  function handleWalletError(e: WalletError) {
    notify('error', `Wallet Error: ${e.message}`)
  }

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider
        onError={(e: WalletError) => handleWalletError(e)}
        wallets={wallets}
        autoConnect
      >
        <NavBar />
        <Divider orientation="horizontal" flexItem className={'App-divider'} />
        <OpenLoan />
        <p>
          <br />
        </p>
        <MainBox />
        <BottomBar />
      </WalletProvider>
    </ConnectionProvider>
  )
}
